import { useEffect, useRef } from 'react';

const ScriptSureIframe = ({
    open,
    sourceUrl,
    setScriptSureLoading,
    triggerFunction,
}: {
    open: boolean;
    sourceUrl: string;
    setScriptSureLoading: (value: boolean) => void;
    triggerFunction: () => void;
}) => {
    const iframeRef = useRef<HTMLIFrameElement>(null);

    useEffect(() => {
        const handleMessage = (event: MessageEvent) => {
            const childWindow = iframeRef.current?.contentWindow;
            if (event.source === childWindow){
                triggerFunction();
            }
        };
        
        // iframe closure listener
        // triggers the fucntion when the iframe becomes empty.
        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    if (!open) return null;

    return (
        <div className="scriptsure-iframe">
            <iframe
                ref={iframeRef}
                src={sourceUrl}
                id="scriptsure-iframe"
                width="100%"
                loading={'lazy'}
                height="100%"
                title="HospisRx"
                onLoad={() => {
                        setScriptSureLoading(false)
                    }
                }
            />
        </div>
    );
};

export default ScriptSureIframe;
